export const NZ_TIME_ZONE = 'Pacific/Auckland'
export const ITEMS_PER_PAGE = 10

export const fmtMoney = value => 'NZ' + String.fromCharCode(36) + Number(value || 0).toFixed(2)

export const formatNZDateTime = value => {
  if (!value) return ''
  return new Date(value).toLocaleString('en-NZ', {
    timeZone: NZ_TIME_ZONE,
    dateStyle: 'short',
    timeStyle: 'short'
  })
}

export const formatNZDate = value => {
  if (!value) return ''
  return new Date(value).toLocaleDateString('en-NZ', { timeZone: NZ_TIME_ZONE })
}

export const formatNZTime = value => {
  if (!value) return ''
  return new Date(value).toLocaleTimeString('en-NZ', {
    timeZone: NZ_TIME_ZONE,
    hour: '2-digit',
    minute: '2-digit'
  })
}

export const getItemName = item => item?.name || 'Item'
export const getItemPrice = item => Number(item?.price || 0)
export const getItemQty = item => Number(item?.qty || 1)

export const getItemsSummary = items => {
  if (!Array.isArray(items) || items.length === 0) return ''
  return items.map(i => getItemName(i) + ' x' + getItemQty(i)).join(', ')
}

export const getItemsExportSummary = items => {
  if (!Array.isArray(items) || items.length === 0) return ''
  return items.map(i => getItemName(i) + ' x' + getItemQty(i) + ' @ ' + fmtMoney(getItemPrice(i))).join('; ')
}

export const getPeriodStart = period => {
  const now = new Date()
  const from = new Date(now)
  if (period === 'today') {
    from.setHours(0, 0, 0, 0)
  } else if (period === 'week') {
    from.setDate(now.getDate() - 7)
    from.setHours(0, 0, 0, 0)
  } else if (period === 'month') {
    from.setDate(1)
    from.setHours(0, 0, 0, 0)
  } else if (period === 'all') {
    return null
  }
  return from
}

export const normalizeText = value => String(value || '').toLowerCase().trim()

export const fuzzyIncludes = (source, query) => {
  const text = normalizeText(source)
  const q = normalizeText(query)
  if (!q) return true
  if (text.includes(q)) return true

  let cursor = 0
  for (const char of q) {
    cursor = text.indexOf(char, cursor)
    if (cursor === -1) return false
    cursor += 1
  }
  return true
}

export const saleSearchText = sale => {
  const itemText = Array.isArray(sale.items)
    ? sale.items.map(i => getItemName(i) + ' ' + getItemQty(i) + ' ' + getItemPrice(i)).join(' ')
    : ''
  return [
    sale.customer_name,
    sale.payment_method,
    sale.total_amount,
    fmtMoney(sale.total_amount),
    sale.notes,
    sale.staff_email,
    itemText,
    formatNZDateTime(sale.created_at)
  ].filter(Boolean).join(' ')
}

export const filterSales = (sales, filters = {}) => {
  const query = normalizeText(filters.query)
  const method = filters.paymentMethod || 'all'

  return (sales || []).filter(sale => {
    const matchesMethod = method === 'all' || sale.payment_method === method
    const matchesQuery = !query || fuzzyIncludes(saleSearchText(sale), query)
    return matchesMethod && matchesQuery
  })
}

export const calculateSalesSummary = sales => {
  const total = (sales || []).reduce((sum, sale) => sum + Number(sale.total_amount || 0), 0)
  const byMethod = (sales || []).reduce((acc, sale) => {
    const key = sale.payment_method || 'Other'
    acc[key] = (acc[key] || 0) + Number(sale.total_amount || 0)
    return acc
  }, {})
  return { total, count: (sales || []).length, byMethod }
}

export const paginate = (rows, page, perPage = ITEMS_PER_PAGE) => {
  const totalPages = Math.max(1, Math.ceil((rows || []).length / perPage))
  const safePage = Math.min(Math.max(1, page), totalPages)
  return {
    page: safePage,
    totalPages,
    rows: (rows || []).slice((safePage - 1) * perPage, safePage * perPage)
  }
}

export const csvEscape = value => '"' + String(value ?? '').replace(/"/g, '""') + '"'

export const buildSalesCsv = sales => {
  const rows = [['Date', 'Time', 'Payment', 'Customer', 'Items', 'Notes', 'Staff', 'Total']]
  ;(sales || []).forEach(sale => {
    rows.push([
      formatNZDate(sale.created_at),
      formatNZTime(sale.created_at),
      sale.payment_method || '',
      sale.customer_name || 'Walk-in',
      getItemsExportSummary(sale.items),
      sale.notes || '',
      sale.staff_email || '',
      Number(sale.total_amount || 0).toFixed(2)
    ])
  })
  return rows.map(row => row.map(csvEscape).join(',')).join('\n')
}
